<template>
  <modal-confirm :show="confirmInstall" title="Instalação" message="Que tal instalar o app?"
    description="Instale esse app no seu dispositivo. Ele ficará disponível na sua tela inicial. Será mais fácil para usá-lo sempre que você precisar."
    @confirm="onConfirmInstall" @cancel="onCancelInstall" />
  <loading v-if="appIsLoading" />

  <!-- <q-pull-to-refresh v-else @refresh="refresh" color="purple-9"> -->
  <router-view v-else-if="!confirmInstall" />
  <!-- </q-pull-to-refresh> -->
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import Loading from './components/ModalLoading.vue';
import { appIsLoading } from 'src/store/state';
import 'src/store/useSync';
import ModalConfirm from './components/ModalConfirm.vue';

const confirmInstall = ref(false);

type BeforeInstallPromptEvent = Event & {
  prompt: () => void;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferredPrompt: BeforeInstallPromptEvent | undefined;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  confirmInstall.value = true;
  deferredPrompt = e as BeforeInstallPromptEvent;
});

const onConfirmInstall = async () => {
  confirmInstall.value = false;
  if (deferredPrompt) {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    deferredPrompt = undefined;
  }
};

const onCancelInstall = () => {
  deferredPrompt = undefined;
  confirmInstall.value = false;
};
</script>
